import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

const freeMessagesService = {
    /**
     * Get free messages status for current user
     * @returns {Promise<{isViewer: boolean, freeMessagesUsed: number, freeMessagesRemaining: number, lastReset: string}>}
     */
    async getStatus() {
        try {
            const tokens = getTokens();
            const response = await axiosInstance.get('/api/free-messages/status', {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching free messages status:', error);
            throw error;
        }
    },

    /**
     * Check if user can send a free message
     * @returns {Promise<{canSend: boolean, reason: string, status: object}>}
     */
    async canSend() {
        try {
            const tokens = getTokens();
            const response = await axiosInstance.get('/api/free-messages/can-send', {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error checking if can send free message:', error);
            throw error;
        }
    },

    /**
     * Use a free message (decrement counter)
     * @returns {Promise<{success: boolean, freeMessagesUsed: number, freeMessagesRemaining: number}>}
     */
    async useFreeMessage() {
        try {
            const tokens = getTokens();
            const response = await axiosInstance.post('/api/free-messages/use', {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error using free message:', error);
            throw error;
        }
    }
};

export default freeMessagesService;
